module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span8"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.label) + ":")])]), _vm._v(" "), _c('uploader', {
    attrs: {
      "max-files": 1000,
      "files": _vm.images2 == null ? [] : _vm.images2
    },
    on: {
      "files-updated": _vm.filesUpdated
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9b85a96","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_block-gallery.vue
// module id = 125
// module chunks = 1